import api from '../axiosInstance'; 
import { APP_SETTINGS } from "../../../../config";

const getAuthHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const createCheckInApi = (attendanceData, token) => {
  return api.post(
    APP_SETTINGS.API_PATH.attendance.create,
    attendanceData,
    getAuthHeaders(token)
  );
};
export const checkInNowApi = (payload, token) => {
  return api.post(APP_SETTINGS.API_PATH.attendance.create, payload, getAuthHeaders(token));
};
export const checkOutNowApi = (payload, token) => {
  return api.patch(APP_SETTINGS.API_PATH.attendance.checkOutUser, payload, getAuthHeaders(token));
};

export const getAllAttendanceApi = (filters, token) => {
  return api.get(APP_SETTINGS.API_PATH.attendance.getAll, {
    params: filters,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteCheckInApi = (id, token) => {
  return api.delete(
    `${APP_SETTINGS.API_PATH.attendance.delete}/${id}`,
    getAuthHeaders(token)
  );
};
export const getAttendanceDetailByIdApi = (id, token) => {
  return api.get(
    `${APP_SETTINGS.API_PATH.attendance.getOne}/${id}`,
    getAuthHeaders(token)
  );
};

export const updateCheckInApi = (id, attendanceData, token) => {
  return api.patch(
    `${APP_SETTINGS.API_PATH.attendance.update}/${id}`,
    attendanceData,
    getAuthHeaders(token)
  );
};


export const startBreakApi = (token) => {
  return api.post(
    APP_SETTINGS.API_PATH.attendance.startBreak, 
    {}, 
    getAuthHeaders(token)
  );
};

export const endBreakApi = (token) => {
  return api.post(
    APP_SETTINGS.API_PATH.attendance.endBreak, 
    {}, 
    getAuthHeaders(token)
  );
};